module.exports = __webpack_public_path__ + "img/BFLLLALA.4eecd77b.jpg";